import React from 'react';

export const SearchIcons = ({ iconName, styles, onClick }) => {
    return (
        <i className="material-icons" style={styles} onClick={onClick}>
            {iconName}
        </i>
    );
};



// WEBPACK FOOTER //
// ./src/components/search/SearchIcons.js